module.exports = __webpack_public_path__ + "img/logo.48ab2e7e.png";